/* Created by Interactive 63 - https://interactive63.com */
/**
 * Collects the distinct colours used by an SVG's fills, strokes and gradient stops, so the
 * colour picker can offer them as swatches. The result is held in memory only.
 */
import { formatColour, parseColour } from '../../../core/colour';

const COLOUR_ATTRIBUTES = ['fill', 'stroke', 'stop-color'];
const COLOUR_STYLE = /(?:^|;)\s*(?:fill|stroke|stop-color)\s*:\s*([^;]+)/gi;

let cachedSource = '';
let cachedColours: string[] = [];

/** Adds a colour to the set when it is a parseable, interpolable colour. */
function note(found: Set<string>, value: string | null): void {
  if (value === null) return;
  const parsed = parseColour(value);
  if (parsed) found.add(formatColour(parsed));
}

/** Returns the distinct colours in an SVG source, in order of first use. */
export function documentColours(source: string): string[] {
  if (source === cachedSource) return cachedColours;
  const found = new Set<string>();
  const doc = new DOMParser().parseFromString(source, 'image/svg+xml');
  for (const el of Array.from(doc.querySelectorAll('*'))) {
    for (const attribute of COLOUR_ATTRIBUTES) note(found, el.getAttribute(attribute));
    const style = el.getAttribute('style');
    if (style) for (const match of style.matchAll(COLOUR_STYLE)) note(found, match[1] ?? null);
  }
  cachedSource = source;
  cachedColours = [...found];
  return cachedColours;
}
